import { CMSBrand, CMSBrandLogo, CMSBrandTaxonomy } from '../types/cms'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Legacy CMS endpoint (CoreMedia CAE, slated for decommissioning):
// the CoreMedia 12 alternative is in CaasApi, switchable via
// REACT_APP_CMS_CAAS_ENABLED.
export const mapCaeBrandsToLogos = (response: CMSBrand[]): CMSBrandLogo[] => {
	if (response.length === 0) return []

	return response.map((item: CMSBrand) => ({
		code:
			item.subjectTaxonomy.filter(
				({ value }: CMSBrandTaxonomy) => value !== 'Logo',
			)[0].value || '-1',
		urlBrandLogo: item.path,
	}))
}

export const CaeApi = createApi({
	reducerPath: 'CmsApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_API_CMS_URL}` || '',
	}),
	endpoints: build => ({
		getBrandsLogo: build.query<CMSBrandLogo[], void>({
			query: () =>
				'/getContent/CMDownload?additionalParams=logo,third-party-logo',
			transformResponse: mapCaeBrandsToLogos,
		}),
	}),
})

export const { useGetBrandsLogoQuery: useGetBrandsLogoCaeQuery } = CaeApi
